import { createAction } from '@reduxjs/toolkit'

export const WS_MESSAGE_PREFIX = 'REDUX_WEBSOCKET'
const createWebsocketType = (type: string): string => `${WS_MESSAGE_PREFIX}::${type}`.toUpperCase()
/**
 * Create an action to receive data from the websocket.
 */
export const websocketAction = <T>(type: string) => createAction<T>(createWebsocketType(type))
